export default __webpack_public_path__ + "static/media/Mu Sigma.32419c13.png";